export default [
    {
        id: 1,
        name_ca: 'Desconeguda',
        name_es: 'Desconocida',
        name_en: 'Unknown'
    }, {
        id: 2,
        name_ca: 'Cap',
        name_es: 'Ninguno',
        name_en: 'None'
    }, {
        id: 3,
        name_ca: 'Estructura vista',
        name_es: 'Estructura vista',
        name_en: 'Naked structure'
    }, {
        id: 4,
        name_ca: 'Pintat',
        name_es: 'Pintado',
        name_en: 'Painted'
    }, {
        id: 5,
        name_ca: 'Enguixat i pintat',
        name_es: 'Enyesado y pintado',
        name_en: 'Plastered and painted'
    }, {
        id: 6,
        name_ca: 'Plaques d\'escaiola',
        name_es: 'Placas de escayola',
        name_en: 'Plaster boards'
    }, {
        id: 7,
        name_ca: 'Plaques de fibres minerals',
        name_es: 'Placas de fibras minerales',
        name_en: 'Mineral fiber plates'
    }, {
        id: 8,
        name_ca: 'Plaques de fibres vegetals',
        name_es: 'Placas de fibras vegetales',
        name_en: 'Mineral fibes plates'
    }, {
        id: 9,
        name_ca: 'Plaques de guix laminat',
        name_es: 'Placas de yeso laminado',
        name_en: 'Gypsum plasterboard'
    }, {
        id: 10,
        name_ca: 'Plaques de fusta',
        name_es: 'Placas de madera',
        name_en: 'Wood paneling'
    }, {
        id: 11,
        name_ca: 'Plaques de fibres minerals aglomerades en humit',
        name_es: 'Placas de fibras minerales aglomeradas en húmedo',
        name_en: 'Agglomerated mineral fiber plates'
    }, {
        id: 12,
        name_ca: 'Lamel·les metàl·liques',
        name_es: 'Lamas metálicas',
        name_en: 'Metallic strips'
    }, {
        id: 13,
        name_ca: 'Plaques metàl·liques',
        name_es: 'Placas metálicas',
        name_en: 'Metal plates'
    }, {
        id: 14,
        name_ca: 'Planxes metàl·liques',
        name_es: 'Planchas metálicas',
        name_en: 'Metal sheets'
    }, {
        id: 15,
        name_ca: 'Plaques de GRC',
        name_es: 'Placas de GRC',
        name_en: 'GRC plates'
    }, {
        id: 16,
        name_ca: 'Plaques d\'aglomerat de ciment amb fibres',
        name_es: 'Placas de aglomerado de cemento con fibras',
        name_en: 'Agglomerated fiber and cement plates'
    }, {
        id: 17,
        name_ca: 'Taulers de partícules aglomerades amb ciment',
        name_es: 'Tableros de partículas aglomeradas con cemento',
        name_en: 'Cement and particles agglomerated panels'
    }, {
        id: 18,
        name_ca: 'Plaques de silicat',
        name_es: 'Placas de silicato',
        name_en: 'Silicate boards'
    }
]





// WEBPACK FOOTER //
// ./src/options/ceilings.js